import { render } from "./EntrancePlantGate.vue?vue&type=template&id=c72c244a&ts=true"
import script from "./EntrancePlantGate.ts?vue&type=script&lang=ts"
export * from "./EntrancePlantGate.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__